import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('holdStatusBadge');

    return {
        HOLD: t('hold')
    };
};

export default useTranslation;
